import { render, staticRenderFns } from "./QuestionDeterminingElementFamily.vue?vue&type=template&id=59648910&scoped=true&"
import script from "./QuestionDeterminingElementFamily.vue?vue&type=script&lang=js&"
export * from "./QuestionDeterminingElementFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59648910",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VRow,VSelect})
